import { setRemoteDefinitions } from '@nx/angular/mf';
// eslint-disable-next-line @typescript-eslint/no-explicit-any
declare let process: any;
const env = process.env.NODE_ENV;
let moduleFederationManifest = '/assets/module-federation.manifest.json';
if (env === 'development') {
  moduleFederationManifest = '/assets/module-federation.dev.manifest.json';
}

fetch(moduleFederationManifest)
  .then((res) => {
    if (!res.ok)
      throw new Error(
        `Failed to load module federation manifest: ${res.status} ${res.statusText}`,
      );
    return res.json();
  })
  .then((definitions) => setRemoteDefinitions(definitions))
  .then(() =>
    import('./bootstrap').catch((err) => {
      // eslint-disable-next-line local-rules/no-console
      console.error(err);
      // Show the fallback error page defined in index.html since the bootstrap module failed to load
      (
        window as { showAppInitError?: (error: string) => void }
      ).showAppInitError?.(err?.message || String(err));
    }),
  )
  .catch((err) => {
    // eslint-disable-next-line local-rules/no-console
    console.error('Critical initialization error:', err);
    //  Show the fallback error page defined in index.html since the module federation manifest failed to load
    (
      window as { showAppInitError?: (error: string) => void }
    ).showAppInitError?.(err?.message || String(err));
  });
